import React, {useEffect, useState} from "react"
import styled from "styled-components"
import Logo from "./Logo";
import useTranslation from "../utils/translation";
import {sizes} from "../utils/media";
import useWindowDimensions from "../utils/windowSize";
import {Link} from "react-router-dom";
import LanguageSelect from "./LanguageSelect";
import {useLocale, useMenu} from "../context/AppContext";
import OutlineMenuIcon from "./icons/OutlineMenuIcon";

const HeaderWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 80px);
  flex-shrink: 0;
  height: ${p => p.isScrolled ? "42px" : "48px"};
  background-color: ${p => p.theme.headerBgColor};
  color: ${p => p.theme.headerTextColor};
  padding: 20px 40px;
  z-index: 998;
  @media only screen and (max-width:${sizes.tablet}px){
    height: 40px;
    padding: 12px 25px;
    width: calc(100% - 50px);
  }
`

const HeaderText = styled.span`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-size: 15px;
  padding: 12px 20px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border: ${p => p.active ? "1px solid white" : "none"};
  :hover {
    color: rgb(255, 255, 255, .6);
  }
`

const NavList = styled.div`
  display: flex;
  flex-direction: row;
`

const Right = styled.div`
  display: flex;
  align-content: center;
  position: absolute;
  right: 0;
`

const Header = () => {
  const t = useTranslation()
  const {language} = useLocale()
  const {menuIsOpen, setMenuIsOpen} = useMenu()
  const {width} = useWindowDimensions();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handler = () => {
      setIsScrolled((prev) => {
        if (!prev && (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20)) return true;
        if (prev && document.body.scrollTop < 4 && document.documentElement.scrollTop < 4) return false;
        return prev;
      });
    };
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const headerNav = () => (
    <NavList>
      <HeaderText><Link to={"/"}>{t("common.start")}</Link></HeaderText>
      <HeaderText><a href={language === "en" ? "https://www.toppowernordic.com/" : "https://www.toppowernordic.se/"} target="_blank" rel="noreferrer">{t("common.powersupply")}</a></HeaderText>
      <HeaderText><a href={"https://shop.toplednordic.com/"} target="_blank" rel="noreferrer">{t("common.productsAndShop")}</a></HeaderText>
      <HeaderText><Link to={"/aboutus"}>{t("common.aboutus")}</Link></HeaderText>
    </NavList>
  )

  return (
    <HeaderWrapper id="header" isScrolled={isScrolled}>
      <Logo/>
      <Right>
        <LanguageSelect/>
        {
          width <= sizes.desktop
            ? !menuIsOpen && <OutlineMenuIcon color={"white"} onClick={() => setMenuIsOpen(!menuIsOpen)}/>
            : headerNav()
        }
      </Right>
    </HeaderWrapper>
  )
}

export default Header
